import React from 'react';

interface Props {
  value: number;
}

export default function SeoScoreCell({ value }: Props) {
  const score = value ?? 0;
  let color: string;
  let bg: string;

  if (score >= 80) {
    color = '#15803d';
    bg = '#dcfce7';
  } else if (score >= 60) {
    color = '#a16207';
    bg = '#fef9c3';
  } else if (score >= 40) {
    color = '#c2410c';
    bg = '#fed7aa';
  } else {
    color = '#dc2626';
    bg = '#fee2e2';
  }

  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 12,
      fontSize: 12,
      fontWeight: 600,
      color,
      background: bg,
      minWidth: 36,
      textAlign: 'center',
    }}>
      {score}
    </span>
  );
}
